import { useState } from 'react';
import { Card, Row, Col, Table, Button, Modal } from 'react-bootstrap';
import CashMovementForm from './CashMovementForm';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const CashSessionActive = ({ session, onRefresh }) => {
  const [showMovementModal, setShowMovementModal] = useState(false);
  const [movementType, setMovementType] = useState(null);

  const resumen = session?.resumen || {};

  // Función para convertir a número de forma segura
  const toNumber = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? 0 : num;
  };

  const handleMovementClick = (type) => {
    setMovementType(type);
    setShowMovementModal(true);
  };

  const handleMovementSubmit = () => {
    setShowMovementModal(false);
    onRefresh();
  };

  const formatDate = (date) => {
    if (!date) return '-';
    return format(new Date(date), "dd/MM/yyyy HH:mm", { locale: es });
  };

  return (
    <>
      <Card className="shadow-sm">
        <Card.Header className="bg-success text-white">
          <h5 className="mb-0">
            <i className="bi bi-check-circle me-2"></i>
            Sesión Activa
          </h5>
        </Card.Header>
        <Card.Body>
          {/* Información General */}
          <Row className="mb-4">
            <Col md={6}>
              <p className="mb-1">
                <strong>Caja:</strong> {resumen.caja || 'N/A'}
              </p>
              <p className="mb-1">
                <strong>Punto de Venta:</strong> {resumen.punto_venta || 'N/A'}
              </p>
            </Col>
            <Col md={6}>
              <p className="mb-1">
                <strong>Apertura:</strong> {formatDate(resumen.fecha_apertura)}
              </p>
              <p className="mb-1">
                <strong>Estado:</strong>{' '}
                <span className="badge bg-success">
                  {resumen.estado?.toUpperCase() || 'ACTIVA'}
                </span>
              </p>
            </Col>
          </Row>

          {/* Resumen Financiero */}
          <Row>
            <Col md={8}>
              <Table bordered size="sm" className="mb-0">
                <tbody>
                  <tr>
                    <td><strong>Monto Inicial:</strong></td>
                    <td className="text-end">
                      ${toNumber(resumen.monto_inicial).toFixed(2)}
                    </td>
                  </tr>
                  <tr className="table-success">
                    <td><strong>Ventas en Efectivo:</strong></td>
                    <td className="text-end text-success fw-bold">
                      + ${toNumber(resumen.monto_ventas_efectivo).toFixed(2)}
                    </td>
                  </tr>
                  <tr className="table-success">
                    <td><strong>Ingresos Adicionales:</strong></td>
                    <td className="text-end text-success">
                      + ${toNumber(resumen.monto_ingresos).toFixed(2)}
                    </td>
                  </tr>
                  <tr className="table-danger">
                    <td><strong>Retiros:</strong></td>
                    <td className="text-end text-danger">
                      - ${toNumber(resumen.monto_retiros).toFixed(2)}
                    </td>
                  </tr>
                  <tr className="table-primary">
                    <td><strong>Efectivo en Caja (Esperado):</strong></td>
                    <td className="text-end fw-bold fs-5">
                      ${toNumber(resumen.monto_esperado).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>

            <Col md={4}>
              <Card className="bg-light">
                <Card.Body>
                  <div className="text-center">
                    <small className="text-muted d-block mb-1">Total Movimientos</small>
                    <h3 className="mb-0">{resumen.total_movimientos || 0}</h3>
                  </div>
                  <hr />
                  <div className="text-center">
                    <small className="text-muted d-block mb-1">Ventas Registradas</small>
                    <h3 className="mb-0 text-success">{resumen.total_ventas || 0}</h3>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Botones de Acción */}
          <Row className="mt-4">
            <Col>
              <div className="d-flex gap-2 justify-content-end">
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => handleMovementClick('retiro')}
                >
                  <i className="bi bi-arrow-down-circle me-1"></i>
                  Registrar Retiro
                </Button>
                <Button
                  variant="outline-success"
                  size="sm"
                  onClick={() => handleMovementClick('ingreso')}
                >
                  <i className="bi bi-arrow-up-circle me-1"></i>
                  Registrar Ingreso
                </Button>
                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={onRefresh}
                >
                  <i className="bi bi-arrow-clockwise me-1"></i>
                  Actualizar
                </Button>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {/* Modal de Movimientos */}
      {showMovementModal && (
        <CashMovementForm
          show={showMovementModal}
          onClose={() => setShowMovementModal(false)}
          onSubmit={handleMovementSubmit}
          sessionId={session.id}
          type={movementType}
        />
      )}
    </>
  );
};

export default CashSessionActive;